// Module Name
export const name = 'policies';

export const typePolicies = {
    GET_POLICIES: `${name}/GET_POLICIES`,
    CREATE_POLICIES: `${name}/CREATE_POLICIES`,
    UPDATE_POLICIES: `${name}/UPDATE_POLICIES`,
    DELETE_POLICIES: `${name}/DELETE_POLICIES`,
    GET_POLICIES_SELFSERVICE: `${name}/GET_POLICIES_SELFSERVICE`,
    GET_PLAN: `${name}/GET_PLAN`,
};
